import React from 'react';
import { useQuery, gql } from '@apollo/client';
import PropTypes from 'prop-types';
import Spinner from 'components/Spinner';

export const MARKETS_QUERY = gql`
  query markets {
    markets(count: 15) {
      id
      name
      position {
        lat
        lng
      }
      __typename
      externalId
      cities {
        id
        name
        position
        state
        externalId
        neighborhoods {
          id
          name
          yearlyPricePerFoot
          externalId
          __typename
        }
      }
    }
  }
`;

const MarketSelector = ({
  onMarketChange,
  selectedMarket,
  className,
  name,
}) => {
  const { data, loading } = useQuery(MARKETS_QUERY);
  if (loading) return <Spinner />;
  return (
    <div className={`select ${className}`}>
      <select
        name={name}
        onChange={(e) => {
          onMarketChange(
            data.markets.find((market) => market.name === e.target.value)
          );
        }}
        defaultValue={selectedMarket?.name}
      >
        {data?.markets?.map((market) => (
          <option key={`market-${market.id}`} value={market.name}>
            {market.name}
          </option>
        ))}
      </select>
    </div>
  );
};

MarketSelector.propTypes = {
  onMarketChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  selectedMarket: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
};
MarketSelector.defaultProps = {
  name: 'marketsSelect',
  className: '',
};

export default MarketSelector;
